import request from '../../utils/request';

export const saveBeaconService = (data, id = 0) => {
  const dataToSend = {
    data,
  };
  if (id > 0) {
    
    return async dispatch => {
      const response = await dispatch(
        request('/beacons/' + id, {
          method: 'PUT',
          data,
        }),
      );
      return response;
    };
  }
  return async dispatch => {
    
    const response = await dispatch(
      request('/beacons', {
        method: 'POST',
        data,
      }),
    );
    return response;
  };
};

export const getBeaconsService = (params = null) => {
  if (params === null) {
    return async dispatch => {
      const response = await dispatch(
        request('/beacons', {
          method: 'GET',
        }),
      );
      return response;
    };
  }
  return async dispatch => {
    const response = await dispatch(
      request('/beacons', {
        method: 'GET',
        params,
      }),
    );
    return response;
  };
};

export const getBeaconByIdService = id => {
  return async dispatch => {
    const response = await dispatch(
      request('/beacons/' + id, {
        method: 'GET',
      }),
    );
    return response;
  };
};

// export const getBeaconImageByIdService = id => {
//   return async dispatch => {
//     const response = await dispatch(
//       request('/beacons/' + id + '/images', {
//         method: 'GET',
//       }),
//     );
//     return response;
//   };
// };

export const getBeaconCompleteByIdService = id => {
  return async dispatch => {
    const response = await dispatch(
      request('/beacons/' + id + '/complete', {
        method: 'GET',
      }),
    );
    return response;
  };
};

// export const getSimpleBeaconListService = (idList = '', all = false) => {
//   return async dispatch => {
//     const response = await dispatch(
//       request('/beacons/exportPdf', {
//         method: 'GET',
//         params: {
//           id: idList,
//           all,
//         },
//       }),
//     );
//     return response;
//   };
// };

// export const getCustomBeaconListService = (idList = '') => {
//   return async dispatch => {
//     const response = await dispatch(
//       request('/beacons/customPdf', {
//         method: 'GET',
//         params: {
//           id: idList,
//         },
//       }),
//     );
//     return response;
//   };
// };
